import HeaderBanner from './HeaderBanner';
const OctopussInfratructure = () => {

    return (
        <>
            <HeaderBanner heading={'Octopuss Infratructure'} imagePath="assets/images/banners/infratructure.avif" />
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row" >
                        <div className='center-heading'>
                            <h2 className="heading-with-border center-heading">Octopuss Infratructure</h2>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default OctopussInfratructure;